// ═══ FEEDBACK TAB ════════════════════════════════════════════════════════════
import React from "react";
import { t } from './i18n';
import { fmAlert } from './dialog';
import { saveFeedback } from './supabase';

export function FeedbackTab({session, currentTab}) {
  const [category, setCategory] = React.useState("sugestie");
  const [message, setMessage] = React.useState("");
  const [rating, setRating] = React.useState(0);
  const [sent, setSent] = React.useState(false);
  const [sending, setSending] = React.useState(false);

  const categories = [
    {id:"sugestie", label:"💡 "+t("Sugestie"), desc:t("O idee de îmbunătățire")},
    {id:"problema", label:"🐞 "+t("Problemă"), desc:t("Ceva nu funcționează")},
    {id:"design", label:"🎨 "+t("Design"), desc:t("Aspect / ușurință în utilizare")},
    {id:"lauda", label:"❤️ "+t("Apreciere"), desc:t("Ceva ce îți place")},
    {id:"general", label:"💬 "+t("Altceva"), desc:t("Orice alt gând")},
  ];

  async function submit() {
    if(!message.trim()) { fmAlert(t("Scrie câteva cuvinte înainte de a trimite.")); return; }
    setSending(true);
    const res = await saveFeedback({category, message:message.trim(), rating:rating||null, context:currentTab}, session);
    setSending(false);
    if(res.error) { fmAlert(t("Nu s-a putut trimite: ")+res.error); return; }
    setSent(true); setMessage(""); setRating(0);
    setTimeout(()=>setSent(false), 4000);
  }

  return (
    <div>
      <div style={{fontSize:13,color:"var(--text-2)",marginBottom:16,lineHeight:1.6,marginTop:4}}>
        {t("Părerea ta contează! Spune-ne ce ți-a plăcut, ce te-a încurcat sau ce ai vrea să adăugăm. Fiecare mesaj ajunge direct la echipa care dezvoltă aplicația.")}
      </div>

      {sent&&(
        <div style={{padding:"12px 16px",background:"var(--green-bg-soft)",border:"1px solid var(--green-line)",borderRadius:10,marginBottom:16,color:"var(--green)",fontSize:14,display:"flex",alignItems:"center",gap:8}}>
          ✓ {t("Mulțumim! Feedback-ul tău a fost trimis.")}
        </div>
      )}

      <div style={{marginBottom:16}}>
        <div className="lbl" style={{marginBottom:8}}>{t("Ce fel de feedback?")}</div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {categories.map(c=>(
            <button key={c.id} onClick={()=>setCategory(c.id)}
              style={{textAlign:"left",padding:"12px 14px",borderRadius:10,cursor:"pointer",
                background:category===c.id?"var(--blue-bg)":"var(--surface)",
                border:`1px solid ${category===c.id?"#7c3aed":"var(--border-2)"}`,
                display:"flex",flexDirection:"column",gap:2}}>
              <span style={{fontSize:14,fontWeight:600,color:"var(--text)"}}>{c.label}</span>
              <span style={{fontSize:12,color:"var(--text-3)"}}>{c.desc}</span>
            </button>
          ))}
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <div className="lbl" style={{marginBottom:8}}>{t("Cât de mulțumit ești de aplicație? (opțional)")}</div>
        <div style={{display:"flex",gap:8}}>
          {[1,2,3,4,5].map(n=>(
            <button key={n} onClick={()=>setRating(n===rating?0:n)}
              style={{fontSize:28,background:"none",border:"none",cursor:"pointer",filter:n<=rating?"none":"grayscale(1) opacity(0.4)",transition:"all .15s"}}>
              ⭐
            </button>
          ))}
        </div>
      </div>

      <div style={{marginBottom:16}}>
        <div className="lbl" style={{marginBottom:8}}>{t("Mesajul tău")}</div>
        <textarea value={message} onChange={e=>setMessage(e.target.value)}
          placeholder={t("Scrie aici gândurile tale...")} rows={6}
          style={{width:"100%",boxSizing:"border-box",background:"var(--surface)",border:"1px solid var(--border-2)",borderRadius:10,color:"var(--text)",padding:"12px",fontSize:14,fontFamily:"inherit",resize:"vertical",lineHeight:1.5}}/>
      </div>

      <button className="bp" style={{width:"100%"}} onClick={submit} disabled={sending}>
        {sending?t("Se trimite..."):"📨 "+t("Trimite feedback")}
      </button>

      <div style={{fontSize:11,color:"var(--text-4)",textAlign:"center",marginTop:12,lineHeight:1.5}}>
        {t("Feedback-ul include adresa ta de email (pentru a te putea contacta).")}
      </div>
    </div>
  );
}
